import React from "react";
import { SovosToolbarGroup, SovosToolbarActions } from "mosaic-react";
import { DefaultToolbar } from "colbi_web_ui/lib/components";
import DatagridExportButton from "../DatagridExportButton/DatagridExportButton";

const CustomCsvToolbar = ({ defaultToolbarProps, toolbarProps }) => {
    const { data, exportableArray } = toolbarProps || {};
    return (
        <SovosToolbarGroup sx={{ width: "100%", justifyContent: "flex-end" }}>
            <SovosToolbarActions>
                <DatagridExportButton data={data} exportableArray={exportableArray} />
                <DefaultToolbar {...defaultToolbarProps} />
            </SovosToolbarActions>
        </SovosToolbarGroup>
    );
};

export default CustomCsvToolbar;


